<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2023-12-26 09:38:16
!-->
<template>
  <div id="index" class="index">
    <div class="settings">
        <img src="../../assets/img/manage/settings/pic_setting_1.png" width="279px" height="104px" @click="togo(0)">
        <img src="../../assets/img/manage/settings/pic_setting_2.png" width="279px" height="104px" @click="togo(1)">
        <img src="../../assets/img/manage/settings/pic_setting_3.png" width="279px" height="104px" @click="togo(2)">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 父辈向子辈传参
  },
  name: "index",
  data() {
    return {};
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
  },
  methods: {
    // 方法
	togo(index) {
		if (index == 0) {
			this.$router.push({ path: "/commodities" });
		}
		else if (index == 1) {
			this.$router.push({ path: "/companyProfile" });
		} else {
			this.$router.push({ path: "/accountDetails" });
		}
	}
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang='scss'>
.settings{
    display: flex;
    justify-content: left;
    img{
        margin-right: 24px;
		cursor: pointer;
    }
}
</style>